import { render, staticRenderFns } from "./IhbarnameAdresBilgileriForm.vue?vue&type=template&id=ac9dc5b8"
import script from "./IhbarnameAdresBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./IhbarnameAdresBilgileriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports